// extracted by mini-css-extract-plugin
export default {"off_canvas":"style_off_canvas__I-v-x"};